import { ref } from "../../../types/_types";

import { Artifact } from "./Artifact";

export const ArtifactRef = ref(Artifact);
